module.exports = __webpack_public_path__ + "img/evier.eeb0099.svg";